import {API} from '@/vue-plugins/api';
let o = {
    namespaced:true
}

o.state = {
    project:{},
    scenes:[],
    scene:{},
    is_ready:false
}

o.getters = {
    is_ready(state){
        return state.is_ready
    },
    project(state){
        return state.project
    },
    scenes(state){
        return state.scenes
    },
    scene(state){
        return state.scene
    }
}

o.actions = {
    loadProject(context, id){
        return new Promise((resolve, reject)=>{
            API.get(`/uav/projects/${id}`).then(res=>{
                context.commit('saveProject', res.data.data)
                resolve(res.data.data)
            })
        })
    },
    loadScenes(context,id){
        return new Promise((resolve, reject)=>{
            API.get(`/uav/projects/${id}/scenes`).then(res=>{
                context.commit('saveScenes', res.data.data)
                resolve(res.data.data)
            })
        })
    },
    loadScene(context,id){
        return new Promise((resolve, reject)=>{
            API.get(`/uav/scenes/${id}`).then(res=>{
                context.commit('saveScene', res.data.data)
                resolve(res.data.data)
            })
        })
    },
    patchScene(context,scene){
        return new Promise((resolve, reject)=>{
            API.patch(`/uav/scenes/${scene.id}`,scene).then(res=>{
                context.commit('saveScene', res.data.data)
                resolve(res.data.data)
            })
        })
    },
    postScene(context,scene){
        return new Promise((resolve, reject)=>{
            API.post(`/uav/scenes`,scene).then(res=>{
                context.commit('saveScene', res.data.data)
                resolve(res.data.data)
            })
        })
    },
    deleteScene(context,id){
        return new Promise((resolve, reject)=>{
            API.delete(`/uav/scenes/${id}`).then(res=>{
                context.commit('deleteScene', id)
                resolve(res.data.data)
            })
        })
    }
}

o.mutations = {
    saveProject(state, project){
        state.project = project
        state.is_ready = true
    },
    saveScenes(state, scenes){
        // 按 order 排序后保存
        state.scenes = [...scenes].sort((a, b) => (a.order || 0) - (b.order || 0))
    },
    saveScene(state, scene){
        const index = state.scenes.findIndex(s => s.id === scene.id)
        if (index !== -1) {
            state.scenes.splice(index, 1, scene)
        } else {
            state.scenes.push(scene)
        }
    },
    deleteScene(state, id){
        state.scenes = state.scenes.filter(scene=>scene.id !== id)
    }
}

export default o